// Import all action creators
// Usage in components: import { action } from 'actions';
import * as advisoryActions from './advisory';
import * as appActions from './app';
import * as filterActions from './filters';
import * as projectsActions from './projects';
import * as projectSystemActions from './project-system';
import * as projectSystemNoteActions from './project-system-notes';
import * as systemActions from './systems';
import * as shoppingCartActions from './shopping-cart';

module.exports = {
  ...advisoryActions,
  ...appActions,
  ...filterActions,
  ...projectsActions,
  ...projectSystemActions,
  ...projectSystemNoteActions,
  ...systemActions,
  ...shoppingCartActions,
};



// WEBPACK FOOTER //
// ./js/actions/index.js